import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";

export default function Error({ message, handleCloseClick }) {
  return (
    <AnimatePresence>
      {message ? (
        <Wrapper
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
        >
          <Message>
            {message || `Oh no! Something went wrong. Please try again later.`}
          </Message>

          {handleCloseClick ? (
            <ButtonWrapper>
              <FnrButton size="small" onClick={handleCloseClick}>
                Got it
              </FnrButton>
            </ButtonWrapper>
          ) : null}
        </Wrapper>
      ) : null}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  font-weight: 400;
  color: #be353b;
  display: flex;
  justify-content: space-between;

  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

const Message = styled.div`
  flex: 1;
`;

const ButtonWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 5px;
`;
